import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  courseImageAlt: {
    id: 'portal.components.catalogue.courseImageAlt',
    defaultMessage: 'Course image',
    description: 'Course image alt text',
  },
  noDescription: {
    id: 'portal.components.catalogue.noDescription',
    defaultMessage: 'No description available',
    description: 'No description available text',
  },
  timeLabel: {
    id: 'portal.components.catalogue.time.label',
    defaultMessage: 'Time',
    description: 'Time label',
  },
  accessLabel: {
    id: 'portal.components.catalogue.access.label',
    defaultMessage: 'Access',
    description: 'Access label',
  },
  complete: {
    id: 'portal.components.catalogue.complete.label',
    defaultMessage: 'Complete',
    description: 'Complete label',
  },
  availableNow: {
    id: 'portal.components.catalogue.availableNow.label',
    defaultMessage: 'Available Now',
    description: 'Available Now label',
  },
  completePreviousModule: {
    id: 'portal.components.catalogue.completePreviousModule.label',
    defaultMessage: 'Complete Previous Module',
    description: 'Complete Previous Module label',
  },
});

export default messages;
